"use client";

import posthog from "posthog-js";
import { registerDesktopAppContext } from "@/lib/desktop/desktop-analytics";

/** PostHog group type for the customer company. Server events use it too. */
export const ORGANIZATION_GROUP_TYPE = "organization";

export type OrganizationGroupIdentification = {
  id: string;
  name?: string | null;
  plan?: string | null;
  createdAt?: string | null;
  memberCount?: number | null;
};

export type UserIdentificationData = {
  id: string;
  email: string;
  fullName?: string;
  organization: OrganizationGroupIdentification;
};

function organizationGroupProperties(
  organization: OrganizationGroupIdentification
): Record<string, string | number> {
  const properties: Record<string, string | number> = {};
  if (organization.name) {
    properties.name = organization.name;
  }
  if (organization.plan) {
    properties.plan = organization.plan;
  }
  if (organization.createdAt) {
    properties.created_at = organization.createdAt;
  }
  if (typeof organization.memberCount === "number") {
    properties.member_count = organization.memberCount;
  }
  return properties;
}

export function identifyUser(userData: UserIdentificationData) {
  if (typeof window === "undefined") {
    return;
  }

  posthog.register({ organization_id: userData.organization.id });
  registerDesktopAppContext();
  posthog.identify(userData.id, {
    email: userData.email,
    name: userData.fullName,
  });
  // The active organization is a PostHog group, so every later browser
  // event joins the same group as the server business events.
  posthog.group(
    ORGANIZATION_GROUP_TYPE,
    userData.organization.id,
    organizationGroupProperties(userData.organization)
  );
}

export function resetUser() {
  if (typeof window === "undefined") {
    return;
  }
  posthog.reset();
}
